import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common'

import { Grid, darken } from '@mui/material';

import Field from '../../../utils/FormikFields/Field';

import { useFormikContext } from 'formik';

import { useQuery } from '@tanstack/react-query';

import { findDuplicateByPhone } from '../apiService';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';

const WarningMsg = styled(BasicFlex)`
  margin-top: .5rem;
  color: ${props => darken(props.theme.colors.warning, .2)};
`

const Mobile = () => {

  const { values } = useFormikContext() || {};

  const { data: duplicate } = useQuery({
    queryKey: ['customers', values?.mobile_phone],
    queryFn: () => findDuplicateByPhone(values?.mobile_phone),
    enabled: values?.mobile_phone?.length === 10
  })

  return (
    <Grid size={{xs: 12, lg: 4}}>
      <Field 
        name="mobile_phone" 
        label="Mobile Phone (Text if available)" 
        placeholder="(XXX) XXX-XXXX"
        formFieldType="mask" 
        maskFormat="(###) ###-####" 
        maskChar={[' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ']}
      />
      {duplicate?.length > 0 && <WarningMsg justify="flex-start" gap=".8rem">
        <ReportGmailerrorredRoundedIcon />
        <div>Phone number already exists:</div> <SimpleChip label={duplicate?.[0]?.full_name} palette="warning" />
        </WarningMsg>}
    </Grid>
  )
  
};

export default Mobile;